
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'Colorectal_cancer',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/Colorectal_cancer.vue